<template>
  <form class="my-5 mx-5">
    <b-form-group v-for="lang in languages" label-for="name-input">
      <lang-flag :iso="lang.code" :squared="false"/>&emsp; <label>{{lang.name}} / {{getNativeName(lang)}}</label>
      <b-form-input
        v-model="message[lang.code].message"
        id="name-input"
        :placeholder="$t($getConst.pages.scope.enter_name)"
        size="lg"
        required
      ></b-form-input>
    </b-form-group>
    <AppConfirmButtons
      v-if="!isLoading"
      :is-loading="isSubmitting"
      @onSubmit="updateConfigScope"
      :noCancel="true"
    />
  </form>
</template>

<script>
  import {updateConfigScope} from "../../../../api/translate.api";
  import AppFormFeedback from "../../../../components/common/form/AppFormFeedback";
  import languages from "../../../../shared/constants/languages/languages";
  import {getOneLanguageDictionary,i18n, loadDictionaries} from "../../../../shared/locales/i18n";
  import AppConfirmButtons from "../../../../components/common/utils/AppConfirmButtons";
  import {getScopeLanguages} from "../../../../api/scopes.api";

  export default {
    name: "scopeSettingsForm",
    components: {AppFormFeedback, AppConfirmButtons},
    props: {
      scope_id: null,
      scope_name: null,
    },
    data() {
      return {
        languages: [],
        listLanguage : languages,
        value:null,
        message: {},
        isSubmitting: false,
        isLoading: false
      }
    },
    created(){
      this.getScopeLanguages();
    },

    methods: {
      getNativeName(lang) {
        let language = this.listLanguage.find(item => item.code === lang.code);
        return language.nativeName;

      },
      getByScope(){
        if (this.$route.name === this.$getConst.routesNames.administration.maintenanceConfig) {
          this.value = this.$getConst.pages.maintenance.maintenance_message_ + this.scope_name;
        }else{
          this.value = this.$getConst.pages.error.error_message_ + this.scope_name;
        }
        return this.value;
      },
      updateConfigScope() {
        this.isSubmitting = true;
        updateConfigScope(this.scope_id, this.message).then(
          () => {
            this.isSubmitting = false;
            this.$snotify.success(this.$t(this.$getConst.pages.alerts.success_operation));
            loadDictionaries();
          },
          (error) => {
            this.isSubmitting = false;
            this.handleApiError(error);
          }
        )
      },
      getScopeLanguages() {
        this.isLoading = true;
        this.$emit("loading", this.isLoading);
        getScopeLanguages(this.scope_id).then(
          (res) => {
            this.languages = res.data;
            this.languages.forEach(language => {
              sessionStorage.setItem(language.code, JSON.stringify(language.content));
              i18n.setLocaleMessage(language.code, language.content);
              if (this.$route.name === this.$getConst.routesNames.administration.maintenanceConfig) {
                this.$set(this.message, language.code, {type: "maintenance", language: language.code, message: this.$t(this.getByScope(), language.code)})
              } else {
                this.$set(this.message, language.code, {type: "error", language: language.code, message: this.$t(this.getByScope(), language.code)})
              }
            });
            this.isLoading = false;
            this.$emit("loading", this.isLoading);
          },
          (error) => {
            this.handleApiError(error);
            this.isLoading = false;
            this.$emit("loading", this.isLoading);
          }
        )
      }
    },
  }
</script>

<style scoped>

</style>
